import "./capsuleManagerGuide.less";

import { IComponentController, IComponentOptions, IScope } from "angular";
import { CAPSULE_SERVICE, CapsuleService } from "../capsule/capsule.service";
import { val } from "@uirouter/core";

export const CAPSULE_MANAGER_GUIDE_COMPONENT: string= "capsuleManagerGuideComponent";

export class Description {
    private title:string;
    private description:string;

    constructor(title:string, description:string) {
        this.title = title;
        this.description = description;
    }
}

class CapsuleManagerGuideController implements IComponentController {
    static $inject = [CAPSULE_SERVICE, "$scope"];
    private currentIndex: number;
    private isVisible:boolean;
    private descriptions : Description[];
    constructor(private capsuleService: CapsuleService, private $scope:IScope) {
        this.currentIndex = 0;
     var _self_: CapsuleManagerGuideController = this;
        this.capsuleService.isShowHideGuide.subscribe( (value) => {
            $scope.$evalAsync(() => _self_.isVisible = value);
        });
    }

    private showHideGuide():void {
        this.capsuleService.showHideGuide();
    }
    private next():void {
        if (this.currentIndex + 1< this.descriptions.length) {
            this.currentIndex++;
        } else {
            this.skip();
            this.currentIndex = 0;
        }
    }
    private isMultiplePages():boolean {
        return (this.descriptions && this.descriptions.length > 1)? true : false;
    }
    private skip():void {
        this.capsuleService.showHideGuide();
    }
}
export const capsuleManagerGuideComponent: IComponentOptions = {
    controller: CapsuleManagerGuideController,
    template: require("./capsuleManagerGuide.html"),
    bindings: {
        descriptions : "="
    }
    };



// WEBPACK FOOTER //
// ./app/capsule-manager-guide/capsuleManagerGuide.component.ts